import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Button, Col, Row, TextBody } from '../../atoms';
import { FormInput, SelectInput } from '../../molecules';
import { ModalHeader } from '../modal';
import { DateRangeItem } from './date-range-item';
export function StatementsFilterModal({ accountType, accountTypeOptions, dateRangeOptions, dateRangeId, disabled = false, onApplyFilters, onChangeAccountType, onChangeDateRange, onClearFilters, onClose, }) {
    // Vars
    const accountTypeOption = useMemo(() => {
        var _a;
        return ((_a = accountTypeOptions.find(option => option.value === accountType)) !== null && _a !== void 0 ? _a : null);
    }, [accountType]);
    // Handlers
    const handleChangeAccountType = useCallback((accountType) => {
        onChangeAccountType((accountType !== null && accountType !== void 0 ? accountType : null));
    }, [onChangeAccountType]);
    const handleClearFilters = useCallback(() => {
        onClearFilters();
        onClose();
    }, [onClearFilters, onClose]);
    const handleApplyFilters = useCallback(() => {
        onApplyFilters();
        onClose();
    }, [onApplyFilters, onClose]);
    // Render
    return (_jsxs(Col, { style: $.container, children: [_jsx(ModalHeader, { title: "Filter statements", onClose: onClose }), _jsxs(Col, { style: $.content, children: [_jsx(FormInput, { label: "Product", field: "accountType", onChangeValue: handleChangeAccountType, onChangePropName: "onChange", children: ({ onChange }) => (_jsx(SelectInput, { value: accountTypeOption, values: accountTypeOptions, placeholder: "Select product", onChange: option => {
                                onChange === null || onChange === void 0 ? void 0 : onChange(option === null || option === void 0 ? void 0 : option.value);
                            }, getItemId: item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.value) !== null && _a !== void 0 ? _a : ''; }, getItemValue: item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.value) !== null && _a !== void 0 ? _a : ''; }, getSelectedItemTemplate: item => (_jsx(TextBody, { em: true, children: item === null || item === void 0 ? void 0 : item.label })), getItemTemplate: item => _jsx(TextBody, { em: true, children: item === null || item === void 0 ? void 0 : item.label }) })) }), _jsx(Row.L, { style: $.dateRangeContainer, children: dateRangeOptions.map(option => (_jsx(DateRangeItem, { active: dateRangeId === option.id, id: option.id, label: option.label, onPress: onChangeDateRange }, option.id))) })] }), _jsxs(Row.C, { style: $.footer, children: [_jsx(Button, { label: "Clear filters", variant: "tertiary", onPress: handleClearFilters, disabled: disabled, style: $.cta }), _jsx(Button, { label: "Apply filters", variant: "secondary", onPress: handleApplyFilters, disabled: disabled, style: $.cta })] })] }));
}
const $ = StyleSheet.create({
    container: {
        // TODO(Hadrien): fix height of the modal
        minHeight: 498, // temporary fix for the height of the modal
        // TODO(Hadrien): Temporay negative margin:
        //  full width modal should be configurable at the Modal level,
        //  this will happend in the Modal refactoring PR. It will have to take into account padding decrease in RWD
        marginHorizontal: -theme.spacing['6'],
        marginTop: -theme.spacing['6'],
    },
    content: {
        flex: 1,
        gap: theme.spacing['6'],
        paddingHorizontal: theme.spacing['6'],
    },
    containerFeedback: {
        gap: theme.spacing['8'],
    },
    dateRangeContainer: {
        flexWrap: 'wrap',
        gap: theme.spacing['2'],
    },
    footer: {
        marginTop: 'auto',
        paddingTop: theme.spacing['6'],
        paddingHorizontal: theme.spacing['6'],
        columnGap: 10,
        borderTopWidth: 1,
        borderTopColor: theme.color.border.primary,
    },
    cta: { flex: 1 },
});
